var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0449 0.0332031H1.91629C1.19665 0.0332031 0.613281 0.615294 0.613281 1.33334C0.613281 2.05138 1.19665 2.63347 1.91629 2.63347H22.0449C22.7645 2.63347 23.3479 2.05138 23.3479 1.33334C23.3479 0.615294 22.7645 0.0332031 22.0449 0.0332031Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.0379 6.59668H1.91629C1.19665 6.59668 0.613281 7.17877 0.613281 7.89681C0.613281 8.61486 1.19665 9.19695 1.91629 9.19695H22.0379C22.7575 9.19695 23.3409 8.61486 23.3409 7.89681C23.3409 7.17877 22.7575 6.59668 22.0379 6.59668Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.0379 12.8916H1.91629C1.19665 12.8916 0.613281 13.4737 0.613281 14.1917C0.613281 14.9098 1.19665 15.4919 1.91629 15.4919H22.0379C22.7575 15.4919 23.3409 14.9098 23.3409 14.1917C23.3409 13.4737 22.7575 12.8916 22.0379 12.8916Z",
    fill: "#7F7F7F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.cff353da76281f881e16451f88e3eec3.svg";
export { ForwardRef as ReactComponent };